import { getFunctions } from 'firebase/functions'
import { FirebaseApp } from 'firebase/app'

// Custom Firebase Functions configuration for development
export function createFunctions(app: FirebaseApp) {
  const functions = getFunctions(app, 'us-central1')
  
  // In development, we need to handle CORS for callable functions
  if (import.meta.env.DEV) {
    // Override the fetch function to route through our CORS proxy
    const originalFetch = window.fetch
    
    window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
      const url = typeof input === 'string' ? input : input.toString()
      
      // Check if this is a Firebase Functions call
      if (url.includes('us-central1-staychecked-73ef7.cloudfunctions.net')) {
        // Replace with our CORS proxy
        const proxyUrl = url.replace(
          'https://us-central1-staychecked-73ef7.cloudfunctions.net',
          'http://localhost:3001'
        )
        
        
        // Add CORS headers to the request
        const modifiedInit = {
          ...init,
          headers: {
            ...init?.headers,
            'Origin': 'http://localhost:3000',
          },
        }
        
        return originalFetch(proxyUrl, modifiedInit)
      }
      
      // For non-Firebase Functions calls, use the original fetch
      return originalFetch(input, init)
    }
    
  }
  
  return functions
} 